/* eslint-disable func-names */

import translations from '../../translations';
import { MAP_ELEMENT_TYPES } from '../../constants';
import GraphUtils from '../../utils/graph';
import OpenSubflowTab from './OpenSubflowTab';
import ResetControlPoints from './ResetControlPoints';
import mxGraphFactory from "mxgraph";

const { mxClipboard } = new mxGraphFactory();

/**
 * @param {Object} graphView object describing current graph state
 * @param {String} x the X coordinate for the mouse click event
 * @param {String} y the Y coordinate for the mouse click event
 * @description Calcualting the coordnates of the duplicated map element
 */
export const calculateCoordinates = (graphView, x, y) => {

    // We need to take into account the zoom scale and panning
    // of the graph when calculating the coordinates of 
    // the map element we wish to duplicate
    const { scale, translate } = graphView;
    const xCoordinateForPasting = x / scale - translate.x;
    const yCoordinateForPasting = y / scale - translate.y;

    return { x: Math.round(xCoordinateForPasting), y: Math.round(yCoordinateForPasting) };
};

/**
 * @param {Object} graph Current mxGraph instance
 * @param {String} flowId
 * @param {String} tenantId
 * @param {String} editingToken
 * @param {String} authenticationToken
 * @param {Function} addNotification
 * @description Displays a custom mxPopUpMenu for performing copy paste actions on map elements 
 */
const customPopupMenu = (graph, flowId, tenantId, editingToken, authenticationToken, addNotification) => {

    graph.popupMenuHandler.factoryMethod = function factoryMethod(menu, cell, event) {

        if (cell) {
            const mapElementType = cell.style;

            if (mapElementType !== MAP_ELEMENT_TYPES.start && mapElementType !== MAP_ELEMENT_TYPES.outcome) {
                menu.addItem(translations['copy map element'], null, () => {
                    mxClipboard.setCells(cell);
                    addNotification({
                        type: 'success',
                        message: `Copied ${cell.value.name} to clipboard`,
                        isPersistent: false,
                    });
                });
            }

            if (mapElementType === MAP_ELEMENT_TYPES.subflow) {
                menu.addItem(translations['open subflow'], null, () => {
                    OpenSubflowTab(
                        cell,
                        flowId,
                        tenantId,
                        editingToken,
                        authenticationToken,
                    );
                });
            }

            if (mapElementType === MAP_ELEMENT_TYPES.outcome) {
                menu.addItem(translations['reset outcome'], null, () => {
                    ResetControlPoints(
                        cell,
                        flowId,
                        tenantId,
                        editingToken,
                        authenticationToken,
                        addNotification,
                    );
                });
            }

        } else {
            menu.addItem(translations['paste map element'], null, () => {
                const coordinates = calculateCoordinates(
                    graph.view, event.x, event.y,
                );

                GraphUtils.duplicateMapElement(
                    flowId,
                    tenantId,
                    editingToken,
                    authenticationToken,
                    addNotification,
                    coordinates.x,
                    coordinates.y,
                    mxClipboard
                );
            });
        }
    
    };
};

export default customPopupMenu;
